var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EasyDataList',{attrs:{"data-source-name":_vm.dataSourceName,"diy-colums":_vm.columns,"action-props":{showExportBtn:false,showAddBtn:false},"table-props":{isOperate: false}},on:{"handleCurrentChange":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }